<footer>
  <div class="links-asso">
    <p>© 2025</p>
    <p class="separate">-</p>
    <p>A l’asso !</p>
    <p class="separate">-</p>
    <p>Tous droits réservés</p>
    <p class="separate">-</p>
    <a routerLink="/cgu" class="footer-link">Conditions Générales</a>
    <p class="separate">-</p>
    <a routerLink="/politique-confidentialite" class="footer-link">Confidentialité</a>
  </div>

  <div class="social-networks">
    <button type="button" (click)="navigate('instagram')" aria-label="Instagram">
      <img src="/social-networks/instagram.png" alt="Instagram" />
    </button>
    <button type="button" (click)="navigate('twitter')" aria-label="Twitter">
      <img src="/social-networks/twitter.png" alt="Twitter" />
    </button>
    <button type="button" (click)="navigate('facebook')" aria-label="Facebook">
      <img src="/social-networks/facebook.png" alt="Facebook" />
    </button>
  </div>
</footer>
